"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _MetricsConfiguration_1 = require("./_MetricsConfiguration");
exports.GetBucketMetricsConfigurationOutput = {
    type: "structure",
    required: [],
    members: {
        MetricsConfiguration: {
            shape: _MetricsConfiguration_1._MetricsConfiguration
        }
    },
    payload: "MetricsConfiguration"
};
//# sourceMappingURL=GetBucketMetricsConfigurationOutput.js.map